import React from 'react';

import BetTimeRoomContentPC from './BetTimeRoomContentPC';
import BetTimeRoomContentSP from './BetTimeRoomContentSP';

const RESPONSIVE_MODE = {
  MOBILE: 'mobile',
  DESKTOP: 'desktop',
};

const hasInsufficientRoomPoints = (viewProps) => {
  if (Number(viewProps?.round?.type) !== 0) {
    return false;
  }

  const minimumBet = Number(viewProps?.event?.minimum_bet ?? 0);
  const roomPoint = Number(viewProps?.user?.point ?? 0);

  return minimumBet > 0 && roomPoint < minimumBet;
};

function BetTimeRoomContent({ responsiveMode, viewProps }) {
  const isRoomPointInsufficient = hasInsufficientRoomPoints(viewProps);

  return responsiveMode === RESPONSIVE_MODE.MOBILE
    ? <BetTimeRoomContentSP isRoomPointInsufficient={isRoomPointInsufficient} viewProps={viewProps} />
    : <BetTimeRoomContentPC isRoomPointInsufficient={isRoomPointInsufficient} viewProps={viewProps} />;
}

export default BetTimeRoomContent;
